import {
  stringToNodes
} from "./chunk-2466FZJC.js";
import {
  __spreadValues
} from "./chunk-CWMXXUWU.js";

// src/components/typography/base/getPropDefaults.tsx
function getPropDefaultsBase(props, extra) {
  return __spreadValues({
    block: props.block || false,
    colorProp: props.color,
    displayProp: props.display,
    hideOverflow: props.hideOverflow || false,
    id: props.id,
    display: props.display,
    size: props.size || "Medium",
    textAlign: props.textAlign,
    onClick: props.onClick,
    children: props.children ? stringToNodes(props.children) : null
  }, extra);
}

export {
  getPropDefaultsBase
};
